import React from 'react';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import Spacing from '../../Spacing';

export default function BannerSectionStyle9({ imgUrl, title, subTitle, btnUrl, btnText }) {
  return (
    <div className="container">
      <div className="cs_banner cs_style_9 cs_white_bg cs_radius_30">
        <div className="cs_banner_img">
          <img src={imgUrl} alt="Banenr" />
        </div>
        <h2 className="cs_banner_title cs_fs_72">{parse(title)}</h2>
        <p className="cs_banner_subtitle cs_fs_20 m-0 cs_medium">
          {parse(subTitle)}
        </p>
        <Spacing md="50" lg="40" sm="30" />
        <Link to={btnUrl} className="cs_btn cs_style_1">
          <span>{btnText}</span>
          <i>
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
            <img src="/images/icons/arrow_white.svg" alt="Icon" />
          </i>
        </Link>
      </div>
    </div>
  );
}
